import React, {useEffect, useState} from "react";
import TemplateCard from "./TemplateCard";
import SurveysPagination from "../../surveys_pagination/SurveysPagination";

function TemplatesList(props) {
    const {isInSearch, templates, allTemplates} = props;
    const [resultsAreFound, setResultsAreFound] = useState(true);
    const [selectedPage, setSelectedPage] = useState(1);

    useEffect(() => {
        setResultsAreFound(templates.length !== 0);
        setSelectedPage(1);
    }, [templates])

    const listItems = (templates) => {
        if (templates) {
            return templates.map(template =>
                <TemplateCard
                    key={template.questId}
                    surveyId={template.questId}
                    name={template.questTitle}
                    mediaId={template.mediaId}/>);
        } else return [];
    }

    const renderingTemplates = resultsAreFound ? templates : allTemplates;
    const noTemplatesPerPage = 16;
    const selectedPageTemplates = renderingTemplates.slice((selectedPage-1)*noTemplatesPerPage, selectedPage*noTemplatesPerPage);
    const lastPage = Math.ceil(renderingTemplates.length/noTemplatesPerPage);
    return (
        <div className="template__cards">
            {(isInSearch && !resultsAreFound) && <p className="template__not_found_desktop">
                We could not find what you’re looking for.
                <br/>Please check our available survey templates below:</p>}
            <div className="template__cards__items">
                {listItems(selectedPageTemplates)}
            </div>
            {renderingTemplates.length > noTemplatesPerPage ?
                <SurveysPagination
                    currentPage={selectedPage}
                    lastPage={lastPage}
                    changePageFunction={setSelectedPage} /> : null
            }
        </div>
    );
}

export default TemplatesList;